import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

export default {
  /**
   * @param {number} page
   * @param {number} size
   * @param {{ glosa?: string, idCurso?: number, idAsignatura?: number, idCapitulo?: number }} filtros
   */
  listarPaginado(page, size, filtros = {}) {
    const params = new URLSearchParams();
    if (filtros.glosa) params.append('glosa', filtros.glosa);
    if (filtros.idCurso > 0) params.append('idCurso', filtros.idCurso);
    if (filtros.idAsignatura > 0) params.append('idAsignatura', filtros.idAsignatura);
    if (filtros.idCapitulo > 0) params.append('idCapitulo', filtros.idCapitulo);
    const qs = params.toString();
    return axios.get(`${API_URL}/Video/v1/list/${page}/${size}${qs ? `?${qs}` : ''}`);
  },

  getById(id) {
    return axios.get(`${API_URL}/Video/v1/${id}`);
  },

  guardar(payload) {
    return axios.post(`${API_URL}/Video/v1`, payload);
  },

  relacionarVideoCapitulo(videoId, capId) {
    return axios.post(
      `${API_URL}/Video/v1/RelacionarVideoCapitulo?video=${videoId}&cap=${capId}`
    );
  },

  /**
   * Misma idea que POST Pregunta/v1/{id}/imagen (multipart). El Bearer lo añade el interceptor de axios.
   * @param {number} idVideo
   * @param {File} file
   */
  subirPortada(idVideo, file) {
    const formData = new FormData();
    formData.append('imagen', file);
    // No fijar Content-Type: axios debe enviar multipart/form-data con boundary;
    // si se manda solo "multipart/form-data" sin boundary, el servidor falla al parsear.
    return axios.post(`${API_URL}/Video/v1/${idVideo}/imagen`, formData);
  },
};
